export const collections = [
  {
    id: 'fresh',
    no: '01',
    name: 'Fresh Flowers',
    note: 'Cut this morning',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/0a9d2030d78e6980171043cc5a230587/587ec097-3f6f-459e-9fda-bbab1d2fb4a2_ff-col-fresh.webp',
  },
  {
    id: 'dried',
    no: '02',
    name: 'Dried Flowers',
    note: 'Lasting, sculptural forms',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/0a9d2030d78e6980171043cc5a230587/587ec097-3f6f-459e-9fda-bbab1d2fb4a2_ff-col-dried.webp',
  },
  {
    id: 'objects',
    no: '03',
    name: 'Objects',
    note: 'Vessels made by hand',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/0a9d2030d78e6980171043cc5a230587/587ec097-3f6f-459e-9fda-bbab1d2fb4a2_ff-col-objects.webp',
  },
];